import BackendClient from '../backend-client';
import RegisterSession, { modelFactory } from './model';

export default class RegisterSessionClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  async list() {
    try {
      const response = await this.request('get', 'last-sessions')();
      console.log('list lastsession', response);
      // Si viene vacio significa que es la primera vez que accedemos a la app
      if (response && response.data && response.data.collection_session
        && response.data.collection_session.session.length === 0) {
        /* Para probar el tour en local, cambiar el true por false */
        localStorage.setItem('showTourHome', true);
      } else {
        localStorage.setItem('showTourHome', false);
      }
      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  async unregisterDevice(deviceId) {
    try {
      const response = await this.request('get', `unregisterdevice/${deviceId}`)();

      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  async renameDevice(newName, deviceId) {
    try {
      const response = await this.request('put', `renamedevice/${deviceId}`)({ newName });

      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  async lastAccess() {
    try {
      const response = await this.request('get', 'last-sessions')({
        start: 0,
        size: 1,
      });

      const instance = this.format(response).unique();
      console.log('lastAccess lastsession', instance);
      return instance.sessions.length ? instance.sessions[0] : null;
    } catch (ex) {
      throw this.handleError(ex);
    }
  }
}

export {
  RegisterSession,
};
